import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { allCollection, allRecommendedView,anyItemIsEmbeddedDatasource, isSingleUnpublishedFlowDraft, isSingleUnShareableCollection } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { IShareAction } from '../../ts/ServerApi/types/actionNames';
import { shareContent } from '../actions/ShareContentAction';

export const ShareContentAction: IEntityAction<IContentInfo, IShareAction> = {
  name: EntityActionNames.ShareContent,
  translateName: Messages.share_content_action,
  isVisible: (targetItems: IContentInfo[], appState: AppState) => {
    return FeatureFlags.newShareDialogEnabled && !anyItemIsEmbeddedDatasource(targetItems)
      && !isSingleUnpublishedFlowDraft(targetItems) && !isSingleUnShareableCollection(appState, targetItems);
  },
  isClickable: (availableActions: IShareAction, targetItems: IContentInfo[], state: AppState) => {
    return (availableActions && availableActions.share) || allCollection(targetItems) || allRecommendedView(targetItems);
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return shareContent(targetItems[0]);
  }
};
